import React, { useEffect, useState } from 'react';
import { Log } from '../model/Log';
import { showMessage } from '../services/popup';
import { getLogs, getLogsTemplates } from '../services/service';

const SIZE = 50;

const LogPage: React.FC = () => {
  const [page, setPage] = useState(0);
  const [logs, setLogs] = useState<Log[]>([]);
  const [level, setLevel] = useState('');
  const [templates, setTemplates] = useState<string[]>([]);
  const [pattern, setPattern] = useState('');

  const loadLogs = async (p: number, ptn?: string, lvl?: string) => {
    try {
      setTemplates(await getLogsTemplates());
      setLogs(await getLogs(ptn ?? pattern, p * SIZE, SIZE + 1, lvl ?? level));
    } catch (e) {
      showMessage('Une erreur est survenue: ' + JSON.stringify(e));
    }
  };

  const hasNext = logs.length > SIZE;
  const hasPrevious = page > 0;

  const movePage = (next: number) => {
    if (next >= 0) {
      setPage(next);
      loadLogs(next);
    }
  };

  const search = (value?: string) => {
    const v = value ?? pattern;
    setPattern(v);
    setPage(0);
    loadLogs(0, v, level);
  };

  const selectLevel = (newLevel: string) => {
    setLevel(newLevel);
    setPage(0);
    loadLogs(0, pattern, newLevel);
  };

  useEffect(() => {
    loadLogs(0, '', '');
  }, []);

  return (
    <div className="page-stack">
      <section className="panel">
        <div className="toolbar-row">
          <select value={level} onChange={(e) => selectLevel(e.target.value)}>
            <option value="">Tous niveaux</option>
            <option value="Warning">Warning</option>
            <option value="Information">Information</option>
            <option value="Error">Error</option>
          </select>
          <input value={pattern} onChange={(e) => setPattern(e.target.value)} placeholder="Recherche logs" />
          <button className="primary-btn" onClick={() => search()}>Rechercher</button>
          <div className="pager-inline">
            <button className="ghost-btn" disabled={!hasPrevious} onClick={() => movePage(page - 1)}>Precedent</button>
            <span>Page {page + 1}</span>
            <button className="ghost-btn" disabled={!hasNext} onClick={() => movePage(page + 1)}>Suivant</button>
          </div>
        </div>

        <div className="chips-wrap">
          {templates.map((n, i) => (
            <button key={i} className="chip-btn" onClick={() => search(n)}>{n}</button>
          ))}
        </div>

        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>Id</th>
                <th>Template</th>
                <th>Message</th>
                <th>Date</th>
                <th>Niveau</th>
                <th>Erreur</th>
              </tr>
            </thead>
            <tbody>
              {logs.slice(0, SIZE).map((l, i) => (
                <tr key={i + 1}>
                  <td className="mono">{l.id}</td>
                  <td>{l.messageTemplate}</td>
                  <td>{l.message}</td>
                  <td>{new Date(l.timeStamp).toLocaleDateString()} {new Date(l.timeStamp).toLocaleTimeString()}</td>
                  <td>
                    <span className={`pill ${l.level === 'Error' ? 'bad' : l.level === 'Warning' ? 'warn' : 'ok'}`}>
                      {l.level}
                    </span>
                  </td>
                  <td>{l.exception}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>
    </div>
  );
};

export default LogPage;
